var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.682,
    height: 11.5,
    viewBox: "0 0 19.682 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "URL",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M14.992,16.5H16.3a4.9,4.9,0,0,0,4.766-5,4.9,4.9,0,0,0-4.766-5H14.992",
    transform: "translate(-2.885 -6.5)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    d: "M8.068,6.5h-1.3A4.9,4.9,0,0,0,2,11.5a4.9,4.9,0,0,0,4.766,5h1.3",
    transform: "translate(-2.002 -6.5)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.5a5d63ef2614ca679b9f3592705cbfcd.svg";
export { ForwardRef as ReactComponent };